export default "__VITE_ASSET__VsGKM3vS__"